import {
  map,
  startCase,
  toLower,
  find,
  filter,
  includes,
  isArray,
  get,
} from 'lodash';

export const formatUserLabel = (value) => startCase(toLower(value));

export const USER_ROLE_OPTIONS = map(
  ['TRADER', 'INTERNAL_OPS', 'OPERATOR_ADMIN', 'SUPER_ADMIN', 'DPS_TRADER', 'DOCUMENTATION_USER', 'DEMO_USER'],
  (role) => ({
    value: role,
    label: formatUserLabel(role),
  }),
);

export const ACCOUNT_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'DISABLED', label: 'Disabled' },
];

export const AUDIT_ACTION_TYPES = [
  'USER_CREATED',
  'USER_DELETED',
  'OPERATOR_UPDATED',
  'ROLES_ASSIGNED',
  'ROLES_REMOVED',
  'USER_DISABLED',
  'PASSWORD_RESET',
  'INVITE_RESENT',
  'USER_ACTIVATED',
];

export const AUDIT_ACTION_TYPE_OPTIONS = map(AUDIT_ACTION_TYPES, (actionType) => ({
  value: actionType,
  label: formatUserLabel(actionType),
}));

export const createOperatorOptions = (operatorsList) => map(
  filter(operatorsList, 'operatorId'),
  ({ operatorId }) => ({
    value: operatorId,
    label: operatorId,
  }),
);

export const toggleRole = (roles, value) => {
  if (!value) return [];
  if (isArray(value)) return value;
  return includes(roles, value)
    ? filter(roles, (role) => role !== value)
    : [...roles, value];
};

export const getAppliedFilterValue = (filters, field) => get(find(filters, { field }), 'value.0');

export const getAppliedFilterValues = (filters, field) => get(find(filters, { field }), 'value');

// The service returns a 'hasNext' flag instead of a total count.
export const getTotalRowsCount = ({
  currentPage,
  rowsPerPage,
  count,
  hasNext,
}) => (hasNext
  ? currentPage * rowsPerPage + 1
  : (currentPage - 1) * rowsPerPage + count);

export const createUserManagementColumns = (operatorOptions = []) => ({
  email: {
    label: 'Email',
    visible: true,
    order: 0,
    filterable: false,
    sortable: false,
    minWidth: 260,
  },
  roles: {
    label: 'Role',
    visible: true,
    order: 1,
    filterable: true,
    sortable: false,
    minWidth: 240,
    inputType: 'select',
    inputArgs: USER_ROLE_OPTIONS,
    defaultValue: () => [],
  },
  operator: {
    label: 'Operator',
    visible: true,
    order: 2,
    filterable: true,
    sortable: false,
    minWidth: 140,
    inputType: 'select',
    selectionType: 'single',
    inputArgs: operatorOptions,
    defaultValue: () => '',
  },
  accountStatus: {
    label: 'Account status',
    visible: true,
    order: 3,
    filterable: true,
    sortable: false,
    minWidth: 160,
    inputType: 'select',
    selectionType: 'single',
    inputArgs: ACCOUNT_STATUS_OPTIONS,
    defaultValue: () => '',
  },
  actions: {
    label: '',
    visible: true,
    untoggleable: true,
    order: 4,
    filterable: false,
    sortable: false,
    nonResizable: true,
    minWidth: 128,
  },
});

export const createActivityLogColumns = () => ({
  occurredAt: {
    label: 'Date & time',
    visible: true,
    order: 0,
    filterable: false,
    sortable: false,
    minWidth: 180,
  },
  actionType: {
    label: 'Action',
    visible: true,
    order: 1,
    filterable: false,
    sortable: false,
    minWidth: 180,
  },
  doneBy: {
    label: 'Done by',
    visible: true,
    order: 2,
    filterable: false,
    sortable: false,
    minWidth: 240,
  },
  doneFor: {
    label: 'Done for',
    visible: true,
    order: 3,
    filterable: false,
    sortable: false,
    minWidth: 240,
  },
});
